/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extraction_Status_ReviewedInputs */

const en_extraction_status_reviewed = /** @type {(inputs: Extraction_Status_ReviewedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reviewed`)
};

/**
* | output |
* | --- |
* | "Reviewed" |
*
* @param {Extraction_Status_ReviewedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const extraction_status_reviewed = /** @type {((inputs?: Extraction_Status_ReviewedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extraction_Status_ReviewedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_extraction_status_reviewed(inputs)
});